import { MouseSelectionStates } from "types";
import { SeriesType } from "types/echarts";

export function boxPlotMidstreamHoverLegends({
  params,
  series
}: Partial<MouseSelectionStates>) {
  const dataIndex = params.dataIndex;
  const seriesIndex = params.seriesIndex;
  const hoveredSeries = series[seriesIndex];

  if (params?.seriesType === SeriesType.Custom && params.data?.length > 3) {
    const selectedFacility = params.data[3].toString();

    return {
      hoverLegendItem: selectedFacility,
      hoverLegendGroup: "",
      hoverLegendId: ""
    };
  } else {
    const seriesName = hoveredSeries?.data[dataIndex]?.name ?? "";
    return {
      hoverLegendItem: seriesName,
      hoverLegendGroup: seriesName,
      hoverLegendId: ""
    };
  }
}
